<svg id="svgRef" #svgRef>
  <g>
    <svg #containerRef [attr.height]="height" [attr.width]="width" [attr.viewBox]="viewBox">
      <rect #rectRef [attr.height]="height" [attr.width]="width"></rect>
      <text #textRef></text>
      <g #intersectableContainerRef></g>
    </svg>
  </g>
</svg>
